import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchTestData = createAsyncThunk('test/getAllData', async () => {
	const response = await fetch(
		'https://jsonplaceholder.typicode.com/users?_limit=5'
	);
	const data = await response.json();
	await new Promise((resolve) => setTimeout(resolve, 5000));
	return data;
});

const initialState = {
	items: [],
	loading: true,
	no_of_calls: 10,
} as any;

const testSlice = createSlice({
	name: 'test',
	initialState,
	reducers: {
		increment: (state) => {
			state.no_of_calls++;
		},
		decrement: (state) => {
			state.no_of_calls--;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchTestData.fulfilled, (state, action) => {
			state.loading = false;
			state.items = action.payload;
		});

		builder.addCase(fetchTestData.pending, (state, _) => {
			state.loading = true;
		});
	},
});

export const { decrement, increment } = testSlice.actions;

export default testSlice.reducer;
